import DropdownButton from '@lyra/core/components/DropdownButton'
import { MoreVertical } from '@lyra/core/components/Icon'
import { InstrumentType } from '@lyra/web/constants/instruments'
import { OrderQuoteParams, OrderType, TriggerPrice, TriggerType } from '@lyra/web/constants/order'
import { Position } from '@lyra/web/constants/position'
import TradeFormModal from '@lyra/web/containers/trade/TradeFormModal'
import { formatInstrument, parseInstrumentName } from '@lyra/web/utils/instruments'
import { getDefaultOrderQuoteParams } from '@lyra/web/utils/order'
import React, { useState } from 'react'

type Props = {
  openTakeProfit?: TriggerPrice
  openStopLoss?: TriggerPrice
  position: Position
}

export default function PositionActionDropdown({ openStopLoss, openTakeProfit, position }: Props) {
  const [order, setOrder] = useState<OrderQuoteParams | null>(null)

  const isTriggerOrder = !!order?.trigger_type
  const isOption = parseInstrumentName(position.instrument_name)?.type === InstrumentType.Options

  return (
    <>
      <DropdownButton isPortaled icon={<MoreVertical />} dropdownProps={{ width: 140 }}>
        <DropdownButton.ListItem
          label={'Add Size'}
          onPress={() =>
            setOrder({
              ...getDefaultOrderQuoteParams(position.instrument_name),
              order_type: OrderType.Limit,
              direction: +position.amount >= 0 ? 'buy' : 'sell',
            })
          }
        />
        <DropdownButton.ListItem
          label={'Take Profit'}
          onPress={() =>
            setOrder({
              ...getDefaultOrderQuoteParams(position.instrument_name),
              order_type: isOption ? OrderType.Limit : OrderType.Market,
              trigger_type: TriggerType.TakeProfit,
              amount: Math.abs(+position.amount).toString(),
              direction: +position.amount >= 0 ? 'sell' : 'buy',
              reduce_only: true,
            })
          }
          isDisabled={!!openTakeProfit}
        />
        <DropdownButton.ListItem
          label={'Stop Loss'}
          onPress={() =>
            setOrder({
              ...getDefaultOrderQuoteParams(position.instrument_name),
              order_type: isOption ? OrderType.Limit : OrderType.Market,
              trigger_type: TriggerType.StopLoss,
              amount: Math.abs(+position.amount).toString(),
              direction: +position.amount >= 0 ? 'sell' : 'buy',
              reduce_only: true,
            })
          }
          isDisabled={!!openStopLoss}
        />
      </DropdownButton>
      {order ? (
        <TradeFormModal
          order={order}
          onClose={() => setOrder(null)}
          onSubmitOrder={() => setOrder(null)}
          hideBuySellToggle
          hideReceipt={isTriggerOrder}
          disableTriggers={!isTriggerOrder}
          hideOrderTypeToggle={isTriggerOrder}
          showMarkPrice={isTriggerOrder}
          title={
            order.trigger_type === TriggerType.TakeProfit
              ? 'Add Take Profit'
              : order.trigger_type === TriggerType.StopLoss
              ? 'Add Stop Loss'
              : 'Add Size'
          }
          subtitle={formatInstrument(position.instrument_name, { showExpiry: true })}
        />
      ) : null}
    </>
  )
}
